// src/pages/ItemAdjustment/components/ItemAdjustmentFooter.jsx
import React from "react";
import { useSelector } from "react-redux";
import { Grid } from "antd";
import { selectAuthInfo } from "../../Auth/authSelectors";

const { useBreakpoint } = Grid;

const ItemAdjustmentFooter = () => {
  const totals = useSelector((s) => s.itemAdjustment.footerValues);
  const authInfo = useSelector(selectAuthInfo);
  const currency = authInfo?.currency;
  const screens = useBreakpoint();

  return (
    <div className="transfer-footer">
      <div
        className="footer-row"
        style={{
          justifyContent: "flex-end",
          marginTop: !screens.md ? -8 : 12,
          marginBottom: !screens.md ? 8 : 0,
        }}
      >
        <div style={{ width: 200, textAlign: "right", fontWeight: 700 }}>
          Total: {totals?.total?.toFixed ? totals.total.toFixed(2) : (totals?.total || 0)} {currency}
        </div>
      </div>
    </div>
  );
};

export default ItemAdjustmentFooter;
